module.exports = __webpack_public_path__ + "895700bdb210a9fc6b8ebbe50a687c72.png";